import React, { useEffect, useState } from "react";
import { useMyOrdersQuery } from "../../redux/api/orderApi";
import Loader from "../layout/Loader";
import toast from "react-hot-toast";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import MetaData from "../layout/MetaData";
import { useDispatch } from "react-redux";
import { clearCart } from "../../redux/features/cartSlice";

const MyOrders = () => {
    const { data, isLoading, error } = useMyOrdersQuery();

    const [searchParams] = useSearchParams();
    const dispatch = useDispatch();
    const navigate = useNavigate()

    const orderSuccess = searchParams.get("order_success")

    useEffect(() => {
        if (error) {
            toast.error(error?.data?.message);
        }
        if (orderSuccess) {
            dispatch(clearCart());
            navigate("/me/orders");
        }
    }, [dispatch, navigate, error, orderSuccess]);

    // Orders array
    const orders = data?.orders || [];

    // Pagination state
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const totalPages = Math.max(1, Math.ceil(orders.length / perPage));
    const startIdx = (page - 1) * perPage;
    const endIdx = Math.min(orders.length, startIdx + perPage);
    const currentOrders = orders.slice(startIdx, endIdx);

    if (isLoading) return <Loader />;

    return (
        <>
            <MetaData title="My Orders" />

            <div className="container d-flex justify-content-center" style={{ paddingTop: "160px", paddingBottom: "115px" }}>
                <div className="row justify-content-center w-100">
                    <div className="col-12 col-lg-10">
                        <div className="cart-card shadow-sm rounded-4 border-0 p-4">
                            <div className="d-flex flex-wrap justify-content-between align-items-center mb-3 gap-2">
                                <h2 className="fw-bold m-0 text-gradient">My Orders</h2>
                                <div className="d-flex align-items-center gap-2">
                                    <span className="small" style={{ color: "#e04f6e" }}>Rows per page</span>
                                    <select
                                        className="form-select form-select-sm"
                                        style={{ width: 90 }}
                                        value={perPage}
                                        onChange={(e) => { setPerPage(Number(e.target.value)); setPage(1); }}
                                    >
                                        <option value={5}>5</option>
                                        <option value={10}>10</option>
                                        <option value={20}>20</option>
                                        <option value={50}>50</option>
                                    </select>
                                </div>
                            </div>

                            <div className="d-flex flex-column gap-3">
                                {currentOrders.map((order) => {
                                    const paid = String(order?.paymentInfo?.status || '').toLowerCase() === 'paid';
                                    const delivered = String(order?.orderStatus || '').toLowerCase().includes('delivered');
                                    return (
                                        <div key={order?._id} className="rounded-4 p-3 bg-white shadow-sm">
                                            <div className="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-2">
                                                <h5 className="fw-bold m-0 text-break" style={{ color: '#e04f6e' }}>{order?._id}</h5>
                                                <div className="d-flex align-items-center gap-2 flex-shrink-0">
                                                    <Link to={`/me/order/${order?._id}`} className="btn btn-dark btn-sm" >
                                                        <i className="fa fa-eye"></i>
                                                    </Link>
                                                    <Link to={`/invoice/order/${order?._id}`} className="btn View-btn btn-sm ms-2">
                                                        <i className="fa fa-print"></i>
                                                    </Link>
                                                </div>
                                            </div>

                                            <div className="d-flex flex-wrap gap-4">
                                                <div>
                                                    <div className="small fw-semibold" style={{ color: '#e04f6e' }}>Amount</div>
                                                    <div className="text-break" style={{ color: '#e04f6e' }}>PKR {order?.totalAmount}</div>
                                                </div>
                                                <div>
                                                    <div className="small fw-semibold" style={{ color: '#e04f6e' }}>Payment</div>
                                                    <div className={paid ? 'text-success fw-semibold' : 'text-danger fw-semibold'}>
                                                        {String(order?.paymentInfo?.status || '').toUpperCase()}
                                                    </div>
                                                </div>
                                                <div>
                                                    <div className="small fw-semibold" style={{ color: '#e04f6e' }}>Status</div>
                                                    <div className={delivered ? 'text-success fw-semibold' : 'text-danger fw-semibold'}>
                                                        {order?.orderStatus}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                                {orders.length === 0 && (
                                    <div className="text-center text-muted">No orders found.</div>
                                )}
                            </div>

                            {/* Pagination controls */}
                            {orders.length > 0 && (
                                <div className="d-flex flex-wrap justify-content-between align-items-center mt-3 gap-2">
                                    <div className="small text-muted">Showing {orders.length === 0 ? 0 : startIdx + 1}–{endIdx} of {orders.length}</div>
                                    <div className="d-flex align-items-center gap-2">
                                        <button
                                            className="btn btn-sm btn-outline-secondary"
                                            disabled={page <= 1}
                                            onClick={() => setPage((p) => Math.max(1, p - 1))}
                                        >
                                            Prev
                                        </button>
                                        <span className="small">Page {page} of {totalPages}</span>
                                        <button
                                            className="btn btn-sm btn-outline-secondary"
                                            disabled={page >= totalPages}
                                            onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
                                        >
                                            Next
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default MyOrders;

